/**
 * desc: 获取途家当前环境
 * dev : guoxing
 */

/**
 * 是否是正式环境
 * @returns {Boolean}
 */
function isProdEnv() {
  return getTujiaEnv() === ''
}
/**
 * 获取途家当前环境
 * @returns string
 */
function getTujiaEnv() {
  let env = ''
  if (/tujia.com/.test(location.host)) {
    if (location.host.indexOf('dev') !== -1) {
      env = 'dev'
    } else if (location.host.indexOf('1.fvt') !== -1) {
      env = '1.fvt'
    } else if (location.host.indexOf('2.fvt') !== -1) {
      env = '2.fvt'
    } else if (location.host.indexOf('fvt') !== -1) {
      env = 'fvt'
    }
  }

  return env
}

export default {
  isProdEnv,
  getTujiaEnv
}
